var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-sp-mask",attrs:{"id":"js-navigation-sp-mask"}})
}
var staticRenderFns = []

export { render, staticRenderFns }